export const WALL_OF_LOVE_ROUTE = '/wall-of-love';
